export default __webpack_public_path__ + "static/media/dongle_thinking1.76adbd5e.png";